const isEmptyString = string => !string || /^\s*$/.test(string);

export default isEmptyString;
